import Vue from 'vue'
import VueI18n from 'vue-i18n'

import cn from './lib/cn.js'
import en from './lib/en.js'
import es from './lib/es.js'

Vue.use(VueI18n)

let locale = 'ch'
const localeLanguageCode = navigator.language.toLowerCase()
if (/^zh-/.test(localeLanguageCode) || localeLanguageCode === 'zh') { // 中文(中国大陆简体)、中文（中国台湾，繁体）
  locale = 'ch'
} else if (/^en-/.test(localeLanguageCode) || localeLanguageCode === 'en' || localeLanguageCode === 'tl-ph' || localeLanguageCode === 'tl') { // 美国，英语(英国)，菲律宾
  locale = 'en'
} else if (/^vi-/.test(localeLanguageCode) || localeLanguageCode === 'es') { // 越南
  locale = 'es'
}
locale = localStorage.getItem('language') || locale;
localStorage.setItem('language', locale);
/**
 * 这个用于翻译固定的语句、词汇
 */
const i18n = new VueI18n({
  locale: locale, // 设置语言
  messages: { // 语言包s
    cn,
    en,
    es
  },
  silentTranslationWarn: true
})

/*
  根据模块翻译的封装(只找1层)
  @param str  要翻译的文本
  @param data 翻译的其他配置参数(同$t)
*/
const tt = function (str, data) {
  if (!str) return ''
  if (typeof str !== 'string') {
    return str
  }
  if (str.includes('.')) { // 传了模块
    return i18n.t(str, data)
  }
  // 没传模块
  if (i18n.te(str)) return i18n.t(str, data) || str
  let rs = str
  for (const key in cn) {
    if (i18n.te(key + '.' + str)) {
      rs = i18n.t(key + '.' + str, data)
      break
    }
  }
  return rs || str
}

// 自定义封装了模块的翻译指令
Vue.prototype.$tt = tt

window.$tt = tt

export default {
  i18n, locale
}
